module.exports = __webpack_public_path__ + "static/media/poster.f01ba400.png";